module.exports = __webpack_public_path__ + "static/barbarawork7-d6f8155f58400aaca503010084dd8fc3.jpg";